document.addEventListener("DOMContentLoaded", () => {
  const toc = document.getElementById("toc");
  if (!toc) return;

  const wrapper =
    toc.closest(".prose") ||
    document.querySelector(".prose") ||
    document.querySelector("article");

  if (!wrapper) return;

  const headings = wrapper.querySelectorAll("h2");

  if (headings.length === 0) {
    toc.style.display = "none";
    return;
  }

  toc.style.display = "block";

  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const ul = document.createElement("ul");

  headings.forEach((h, index) => {
    const text = (h.textContent || "").trim();
    if (!text) return;

    if (!h.id) h.id = `toc-${index}-${slugify(text)}`;

    const li = document.createElement("li");
    li.className = "m-toc__h2";

    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.textContent = text;

    li.appendChild(a);
    ul.appendChild(li);
  });

  toc.innerHTML = `<div class="m-toc__title">Table of contents</div>`;
  toc.appendChild(ul);
});